import { BaseEntity } from '../../base-entity';
import { AccountingDocType } from '../../accounting/accounting-documents-entity';
import { PaymentMethodsDb } from '../../students/payment-services/user-payments/user-payment-service-with-price-list';

export enum CrmOperationType {
  Payment = 'payment',
  Refund = 'refund',
}

export interface CrmPaymentEntity extends BaseEntity {
  id: number;
  crmAccountId: number;
  branchId: number | null;
  /**
   * Display-only (when provided by backend joins).
   * Kept optional to avoid breaking older payloads that don't include it.
   */
  branchName?: string | null;
  paymentAmount: number;
  paymentMethodType: PaymentMethodsDb | null;
  operationType: CrmOperationType | null;
}

export interface CrmPaymentWithDocumentEntity extends CrmPaymentEntity {
  fileUrl: string | null;
  docType: AccountingDocType;
  docNumber: number | null;
  branchName: string | null;
}
